import { render } from "./SeckillTime.vue?vue&type=template&id=effd822e&scoped=true&ts=true"
import script from "./SeckillTime.vue?vue&type=script&lang=ts"
export * from "./SeckillTime.vue?vue&type=script&lang=ts"

import "./SeckillTime.vue?vue&type=style&index=0&id=effd822e&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-effd822e"]])

export default __exports__